/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Delete_Selected_Terms_TitleInputs */



/**
* | output |
* | --- |
* | "Delete selected terms" |
*
* @param {Knp_Terms_Delete_Selected_Terms_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_delete_selected_terms_title = /** @type {((inputs?: Knp_Terms_Delete_Selected_Terms_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Delete_Selected_Terms_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer les termes sélectionnés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Begriffe löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina i termini selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить выбранные термины")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar términos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除选定的条款")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択した用語を削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित शब्दों को हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir termos selecionados")
	return /** @type {LocalizedString} */ ("Delete selected terms")
});